import React from 'react'
import { transitions } from 'blocks.app/config'
import type { DropContentProps, DropContentState } from './dropContent.types'

class DropContentMethods extends React.Component<DropContentProps, DropContentState> {
    state: DropContentState = {
        isOpen: this.props.isOpen,
    }
    animationState = true
    animationTimer: ReturnType<typeof setTimeout> | null = null

    componentDidUpdate(prevProps: DropContentProps) {
        const p_ = this.props

        if (p_.animate && prevProps.isOpen && !p_.isOpen) {
            this.animationState = false
            if (this.animationTimer) {
                clearTimeout(this.animationTimer)
            }
            this.animationTimer = setTimeout(() => {
                this.setState({ isOpen: p_.isOpen })
                this.animationState = true
            }, transitions.normal)
            return
        }
        if (prevProps.isOpen !== p_.isOpen) {
            this.setState({ isOpen: p_.isOpen })
        }
    }

    componentWillUnmount() {
        if (this.animationTimer) {
            clearTimeout(this.animationTimer)
        }
    }
    getArrowPosition = (position: string) => {
        switch (position) {
            case 'bottom':
                return 'down'
            case 'top':
                return 'up'
            default:
                return position
        }
    }
}

export default DropContentMethods
